// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25Ulc","fullView":"styles_fullView__2IMSu"};